import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import axios, { AxiosError } from "axios";
import { format } from "date-fns";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { Cards } from "../prismaTypes";
import { readDate } from "../utils/dateUtils";
import { EuroFormatter } from "../utils/EuroFormatter";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export function UserInfo() {
  const role = oraPrenotaStore((state) => state.role);
  const { isLoading, data } = useQuery<
    {
      cards: (Cards & {
        nome: string;
        cognome: string;
        importoResiduo: number;
        dataScadenzaCertificato: string;
        dataScadenza: string;
      })[];
    },
    AxiosError
  >(["cards/findMyCard"], () => axios.get(API_URL + "cards/findMyCard").then((res) => res.data), {
    enabled: role === "USER",
  });

  if (isLoading || !data) return <></>;

  const userData = data.cards[0];

  const dataScadenzaCertificato =
    userData.dataScadenzaCertificato === null ? null : readDate(userData.dataScadenzaCertificato);
  const dtScadenza = userData.dataScadenza === null ? null : readDate(userData.dataScadenza);

  return (
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell>Socio</TableCell>
          <TableCell>
            {userData.nome} {userData.cognome}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Card</TableCell>
          <TableCell>{userData.codice}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Scadenza</TableCell>
          <TableCell>
            {dtScadenza !== null && (
              <span className="UserInfo__cell">
                <span>{format(dtScadenza, "dd/MM/yyyy")}</span>
                {dtScadenza < new Date() && <WarningAmberIcon fontSize={"small"} color={"error"} />}
              </span>
            )}
          </TableCell>
        </TableRow>
        {userData.dataScadenzaCertificato !== null && (
          <TableRow>
            <TableCell>Scad. certificato</TableCell>
            <TableCell>
              {dataScadenzaCertificato !== null && (
                <span className="UserInfo__cell">
                  <span>{format(dataScadenzaCertificato, "dd/MM/yyyy")}</span>
                  {dataScadenzaCertificato < new Date() && (
                    <WarningAmberIcon fontSize={"small"} color={"error"} />
                  )}
                </span>
              )}
            </TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>Saldo</TableCell>
          <TableCell>
            <span className="UserInfo__cell">
              <span>{EuroFormatter.format(userData.importoResiduo)}</span>
              {userData.importoResiduo < 0 && (
                <WarningAmberIcon fontSize={"small"} color={"error"} />
              )}
            </span>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
